import { Checkbox, FormControl, FormControlLabel } from '@material-ui/core';
import React, { useContext } from 'react';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import CheckCircleRoundedIcon from '@material-ui/icons/CheckCircleRounded';
import { VisitsContext } from 'context/VisitsContextProvider';

const CustomCardSelector = ({ slotId }) => {
  const { selectedSlots, setSelectedSlots } = useContext(VisitsContext);

  const handleChange = (e) => {
    const isChecked = e.target.checked;
    isChecked
      ? setSelectedSlots((prev) => [...prev, slotId])
      : setSelectedSlots([...selectedSlots].filter((s) => s !== slotId));
  };

  return (
    <div style={{ position: 'absolute', top: 5, right: 5 }}>
      <FormControl component="fieldset">
        <FormControlLabel
          style={{ margin: 0 }}
          onClick={(event) => event.stopPropagation()}
          control={
            <Checkbox
              size={'small'}
              checked={!!selectedSlots.find((s) => s === slotId)}
              onChange={handleChange}
              onClick={(event) => event.stopPropagation()}
              name="visit"
              // style={{ padding: 0, marginLeft: -13, borderRadius: 25 }}
              icon={<RadioButtonUncheckedIcon />}
              checkedIcon={<CheckCircleRoundedIcon />}
            />
          }
        />
      </FormControl>
    </div>
  );
};

export default CustomCardSelector;
